export default __webpack_public_path__ + "static/media/arrow-right.d3eba1e6.svg";